module.exports = __webpack_public_path__ + "assets/img/securitiesSolutions-maketTrading-bg.4589fa44.png";